import { useAlert } from "@blaumaus/react-alert";
import { AxiosError } from "axios";
import { useTranslation } from "react-i18next";
import { formatDrfErrors } from "../utils/formatDrfErrors";

export default function useErrorHandling() {
  const alert = useAlert();
  const { t } = useTranslation("errors");

  // Accept the default `AxiosError` (data: unknown) so all 100+ call sites
  // can pass through without retyping; we cast to the expected DRF shapes
  // internally below.
  return (error: AxiosError) => {
    // ApiErrorResponse is typed as an object, but at runtime data can also be
    // a raw string (e.g. nginx HTML error pages); cast through `unknown` for
    // the string narrowing branch.
    const data = error.response?.data as unknown as
      | { detail?: string; non_field_errors?: string[]; message?: string }
      | string
      | undefined;
    if (typeof data === "object" && data?.detail) {
      alert.error(data.detail);
    } else if (typeof data === "object" && data?.non_field_errors) {
      alert.error(data.non_field_errors[0]);
    } else if (data) {
      if (typeof data === "string") {
        alert.error(data);
        return;
      }
      const messageOrData = data?.message || data;
      if (typeof messageOrData === "string") {
        alert.error(messageOrData);
        return;
      }
      const errorMessages = formatDrfErrors(messageOrData as { [k: string]: string[] });
      errorMessages.forEach((errorMessage) => alert.error(errorMessage));
    } else {
      alert.error(t("generic"));
    }
  };
}
